import FieldCurrencyR from './FieldCurrencyR';
export default FieldCurrencyR;
